import script from "./MultiviewStreamPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./MultiviewStreamPreview.vue?vue&type=script&setup=true&lang=js"

import "./MultiviewStreamPreview.vue?vue&type=style&index=0&id=0ecb7e04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ecb7e04"]])

export default __exports__